exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__container___22aH3{margin-top:10px}", ""]);

// exports
exports.locals = {
	"container": "style__container___22aH3"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/order-tally/style.css
// module id = 703
// module chunks = 0